import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedValues: {}, // Store multiple radio button selections
};

const radioSlice = createSlice({
  name: "radio",
  initialState,
  reducers: {
    setRadioValue: (state, action) => {
      const { stateName, value } = action.payload;
      state.selectedValues[stateName] = value; // Store selected value dynamically
    },
  },
});

export const { setRadioValue } = radioSlice.actions;
export default radioSlice.reducer;
